import { BaseIP } from "../CommonAPI/CommonApi"


//=============================Terms and condition  Master =============================================
export const TermsAndCondMasterSave=BaseIP+"master/termsAndCondMaster/saveTermsAndCondMaster"  // Save the data
export const TermsAndCondMasterUpdate=BaseIP+"master/termsAndCondMaster/updateTermsAndCondMaster"  // Update the data 
export const TermsAndCondMasterGet=BaseIP+"master/termsAndCondMaster/getTermsAndCondMasterList"  // Get all data
export const TermsAndCondMasterGetById=BaseIP+"master/termsAndCondMaster/getTermsAndCondMaster"  // Get  data by Id
export const TermsAndCondMasterDelete=BaseIP+"master/termsAndCondMaster/deleteTermsAndCondMaster"  // Delete the data